module.exports = __webpack_public_path__ + "static/img/Ashtray 2-4.e02bd57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ashtray 2-4.jpg
// module id = D8E3
// module chunks = 1